import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Module } from '../model/ModuleModel';

@Injectable({
  providedIn: 'root',
})
export class ModulesFilterService {
  private modulesSource = new BehaviorSubject<Module[]>([]);
  private noResultsSource = new BehaviorSubject<boolean>(false); 
  private modulesBackup: Module[] = [];

  modules$ = this.modulesSource.asObservable();
  noResults$ = this.noResultsSource.asObservable(); 

  diacriticsMap = {
    a: new RegExp(/[àáâãäå]/g),
    c: new RegExp(/ç/g),
    e: new RegExp(/[èéêë]/g),
    i: new RegExp(/[ìíîï]/g),
    n: new RegExp(/ñ/g),
    o: new RegExp(/[òóôõö]/g),
    u: new RegExp(/[ùúûü]/g)
  };

  setModules(modules: Module[]): void {
    this.modulesBackup = [...modules];
    this.modulesSource.next(modules);
    this.noResultsSource.next(modules.length === 0);
  }

  filterModules(value: string) {
    if (!value) {
      this.noResultsSource.next(false);
      this.modulesSource.next([...this.modulesBackup]);
    } else {
      value = this.normalizeString(value);
      let filteredResults = 0;
      const modulesFiltered = this.modulesBackup.map((module: any) => {        let result = module;
        if (module.data && module.filtering_field && module.data[module.filtering_field]) {
          if(module.title && this.filterRecursive(module.title.text, value)) {
            filteredResults++;
          } else if(Array.isArray(module.data[module.filtering_field])){
            const filteredModule = JSON.parse(JSON.stringify(module));
            filteredModule.data[module.filtering_field] =
              filteredModule.data[module.filtering_field].filter(card => this.filterRecursive(card, value));
            if(filteredModule.data[module.filtering_field].length > 0) {
              filteredResults++;
              result = filteredModule;
            } else {
              result = null;
            }
          } else if (this.filterRecursive(module.data[module.filtering_field], value)) {
            filteredResults++;
          } else {
            result = null;
          }
        }
        return result;
      }).filter(module => module);
      this.noResultsSource.next(filteredResults === 0);
      this.modulesSource.next(modulesFiltered);
    }
  }

  filterRecursive(value: any, filter: string) {
    if (value && typeof value == 'object') {
      return Object.keys(value).some((key) => {
        return this.filterRecursive(value[key], filter);
      });
    } else if (typeof value == 'string') {
      const valueNormalized: string = this.normalizeString(value);
      return valueNormalized.toLowerCase().includes(filter.toLowerCase());
    } else {
      return false;
    }
  }

  normalizeString(s: string): string {
    let result = s.toLowerCase().normalize('NFC');

    Object.entries(this.diacriticsMap).forEach(entry => {
      const [char, regex] = entry;
      result = result.replace(regex, char);
    });

    return result;
  }
}